// @flow
import React from 'react';
import styled from 'styled-components';

import { colors } from '../../shared/styles';

const StyledDashboard = styled.div`
    padding: 40px;

    h3 {
        margin: 0;
    }

    a {
        color: ${colors.orange.default};
    }
`;

const Dashboard = () => {
    return (
        <StyledDashboard>
            <h3>Welcome to the Network Rail Property Management System.</h3>

            <p>
                All properties on the website can be managed from the Property
                Search tab on the left.{' '}
            </p>

            <p>
                A user guide for the system can be found{' '}
                <a
                    href="http://property.networkrail.co.uk/wp-content/uploads/2018/02/Network-Rail-CMS-Guide.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    here
                </a>.
            </p>

            <p>
                For any technical assistance please contact{' '}
                <a href="mailto:jack@hma.co.uk">jack@hma.co.uk</a>.
            </p>
        </StyledDashboard>
    );
};

export default Dashboard;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Dashboard.js